import React, { useEffect } from 'react'
import { Col, Container, Row } from 'reactstrap'
import BreadCrumb from 'Components/Common/BreadCrumb'
import { useState } from 'react'
import DeleteModal from 'Components/Common/DeleteModal'
import { WarehouseRQ } from 'Hooks/Queries'
import withTable from 'Components/Common/Table/withTable'
import { WarehouseItem } from 'Components/Warehouse/WarehouseItem'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { DATA_LIMIT } from 'configs'

export default function ListWarehouse() {
  const [deleteWarehouseId, setDeleteWarehouseId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(DATA_LIMIT);
  const [keyword, setKeyword] = useState(null);
  const {
    status,
    data,
    error,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch
  } = WarehouseRQ.useGetDataList()(false, keyword, offset, limit);

  const useQuery = useQueryClient(); 
  const navigate = useNavigate();

  const onDeleteSuccess = (key) =>{
    setDeleteModal(false);
    setDeleteWarehouseId(null)
    useQuery.invalidateQueries({queryKey:[key]})
    refetch()
  }
  const { mutate: deleteWarehouse } = WarehouseRQ.useDeleteData(onDeleteSuccess)();

  const onDeleteClick = (id) => {
    setDeleteModal(true);
    setDeleteWarehouseId(id)
  }

  const onDeleteConfirm = () => {
    deleteWarehouse(deleteWarehouseId);
  }

  const onAddButtonClicked = () => {
    navigate('/app/warehouses/create')
  }

  const onPageChange = (i) => {
    setOffset(i.selected);
  }
  
  const onPerPageChange = (i) => {
    setLimit(i);
    setOffset(0);
  }

  const onKeywordChange = (value) => {
    setKeyword(value)
  }

  const WarehouseTable = withTable(
    WarehouseItem, 
    'warehouses', 
    ['NO', 'Action', 'Nama', 'PIC Name', 'PIC Email', 'Address', 'Status'], 
    onDeleteClick, 
    onAddButtonClicked
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Warehouse"/>
        
        <Row>
          <WarehouseTable
            data={data}
            isFetching={isFetching}
            loading={isFetching}
            error={error}
            status={status}
            onPageChange={onPageChange}
            onPerPageChange={onPerPageChange}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            onKeywordChange={onKeywordChange}
            keyword={keyword}
          />
        </Row>
      </Container>
      <DeleteModal
        onDeleteConfirm={() => onDeleteConfirm()}
        onCloseClick={() => setDeleteModal(v => !v)}
        show={deleteModal}
        loading={false}
      />
    </div>
  )
}
